/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.presentationModule')
  .service('BulbPresentationService', [
    '$compile',
    '$document',
    '$rootScope',
    '$state',
    '$timeout',
    'BulbUnitService',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbPresentationService,
  ]);

function BulbPresentationService($compile, $document, $rootScope, $state, $timeout, BulbUnitService) {
  const that = this;
  let fullscreen = false;
  let scale;
  let lastStateArg;
  let fullscreenTarget;
  let zoomTarget;
  // Variable to indicate whether or not we have 'zoomed' in the content or not.
  this.zoomed = false;
  // Variable that indicates the first time the user hits the presentation mode button. This is used when transitioning
  // To another page when already in the presentation mode state.
  this.firstTimePresenting = true;
  let userControllable = false;
  const coverFadeOutDuration = 500;
  const scrollDuration = 200;
  const moveDuration = 100;

  const pageBodyWidth = 815;
  const hMargin = 30;
  const width = pageBodyWidth + hMargin * 2;

  this.usePublishedVersion = false;

  this.getWidth = function getWidth() {
    return Math.min(width, jQuery(window).width());
  };

  /**
   * Function that shows the transition cover on startup of the presentation. This transition is an intermidiate screen
   * that displays the bulb busy logo.
   */
  this.showTransitionCover = function showTransitionCover() {
    if (jQuery('#presentation-transition-cover').length) {
      return;
    }
    const content = $compile('<div id="presentation-transition-cover" class="presentation-transition-cover" '
        + 'bulb-inline-busy></div>')($rootScope);
    jQuery('#bulb-main').append(content);
  };

  const hideTransitionCover = function hideTransitionCover() {
    jQuery('.presentation-transition-cover').fadeOut(coverFadeOutDuration, function fadeOut() {
      jQuery(this).remove();
    });
  };

  this.isFullScreen = function isFullScreen() {
    return fullscreen;
  };

  const onfscreenchange = function onfscreenchange() {
    if (!$.fullscreen.isFullScreen()) {
      that.exitPresentation(false);
    }
  };

  this.enterFullscreen = function enterFullscreen() {
    fullscreen = true;
    zoomTarget = jQuery('#bulb-content');
    fullscreenTarget = jQuery('#bulb-main');
    fullscreenTarget.css('background', '#ececee');
    fullscreenTarget.fullscreen();
    fullscreenTarget.css('overflow-y', 'scroll');
    $document.on('fscreenchange', onfscreenchange);
  };

  const exitFullscreen = function exitFullscreen() {
    fullscreen = false;
    $document.off('fscreenchange', onfscreenchange);
    // document.webkitCurrentFullScreenElement is needed as this is the element to tell if full screen in safari
    if (document.fullscreenElement || document.webkitCurrentFullScreenElement) {
      $.fullscreen.exit();
    }
  };

  const prohibitFullscreenOfEmbedContent = function prohibitFullscreenOfEmbedContent() {
    // embed
    jQuery('#bulb-content').find('iframe').removeAttr('allowfullscreen').removeAttr('webkitallowfullscreen')
      .removeAttr('mozallowfullscreen');

    // jwplayer
    jQuery('#bulb-content').find('.jw-icon-fullscreen').remove();
  };

  const getScrollDistance = function getScrollDistance() {
    return fullscreenTarget.innerHeight() * 0.8;
  };

  const getMoveDistance = function getMoveDistance() {
    return fullscreenTarget.innerHeight() * 0.1;
  };

  const moveUp = function moveUp(scroll) {
    const scrollTop = fullscreenTarget.scrollTop();
    if (scrollTop === 0) {
      if (that.parentUnit.unitType !== 'UserUnit' && that.previousUnit.path) {
        that.changePage(that.previousUnit);
      }
    } else {
      fullscreenTarget.stop().animate({
        scrollTop: scrollTop - (scroll ? getScrollDistance() : getMoveDistance()),
      }, scroll ? scrollDuration : moveDuration);
    }
  };

  const moveDown = function moveDown(scroll) {
    const scrollTop = fullscreenTarget.scrollTop();
    if (scrollTop + jQuery(window).height() >= Math.floor(zoomTarget.innerHeight() * scale) - 1) {
      if (that.parentUnit.unitType !== 'UserUnit' && that.nextUnit.path) {
        that.changePage(that.nextUnit);
      }
    } else {
      fullscreenTarget.stop().animate({
        scrollTop: scrollTop + (scroll ? getScrollDistance() : getMoveDistance()),
      }, scroll ? scrollDuration : moveDuration);
    }
  };

  const onKeyDown = function onKeyDown(event) {
    if (!userControllable) {
      return;
    }
    switch (event.keyCode) {
      case $.ui.keyCode.BACKSPACE:
        exitFullscreen();
        that.exitPresentation(false);
        break;
      case $.ui.keyCode.LEFT:
      case $.ui.keyCode.PAGE_UP:
        moveUp(true);
        break;
      case $.ui.keyCode.RIGHT:
      case $.ui.keyCode.PAGE_DOWN:
      case $.ui.keyCode.SPACE:
        moveDown(true);
        break;
      case $.ui.keyCode.UP:
        moveUp(false);
        break;
      case $.ui.keyCode.DOWN:
        moveDown(false);
        break;
    }
  };

  // Handle when the user clicks anywhere in the presentation mode.
  const onClick = function onClick(event) {
    if (!userControllable) {

    }
  };

  this.zoom = function zoom() {
    zoomTarget = jQuery('#bulb-content');
    fullscreenTarget.css('overflow-x', 'hidden');
    jQuery('header.bulb-header').hide();
    jQuery('.bulb-cover-image').css('z-index', 0);

    $timeout(prohibitFullscreenOfEmbedContent, 1000);

    // set key and click handler
    $document.on('keydown', onKeyDown);
    jQuery('#bulb-main').on('click', onClick);

    // prevent event propagation
    jQuery('#bulb-content').find('.bulb-page-attached-file-title-section').find('a').click((event) => {
      event.stopPropagation();
    });

    that.zoomed = jQuery(window).width() > width;
    if (that.zoomed) {
      zoomTarget.removeClass('bulb-content');
      // origin
      zoomTarget.addClass('presentation-zoom');

      // Calculating the scale for the content when zoomed in.
      const documentWidth = jQuery(document).width();
      scale = parseInt(documentWidth) / width;

      // Grab the current cover image of the page, if the page has one.
      // TODO future: Implement a better way of grabbing the cover image.
      const coverImg = jQuery('.bulb-has-cover-image').find('img');
      if (coverImg.length) {
        coverImg.css('left', -(coverImg.width() - width) / 2);
      } else {
        zoomTarget.css('padding-top', '20px');
      }

      const vscrollbarWidth = zoomTarget.parent().width() - zoomTarget.width();

      // Update the width of the page.
      zoomTarget.width(width);

      // Apply the new scale to the content to make it look 'zoomed' in.
      zoomTarget.css('transform', `scale(${scale},${scale})`);

      // resize
      const w = documentWidth - vscrollbarWidth;
      jQuery('#presentation-footer').width(w);
      jQuery('#presentation-footer-thumbnail-container').width(w);

      const pageViewHeight = jQuery('bulb-page-view').height();
      zoomTarget.parent().height(pageViewHeight);
    } else {
      scale = 1;
      fullscreenTarget.removeClass('bulb-main');
    }

    $timeout(() => {
      userControllable = true;
    }, 300);

    // reset scrollTop
    fullscreenTarget.scrollTop(0);

    // transition
    hideTransitionCover();
  };

  this.restoreZoom = function restoreZoom() {
    if (that.zoomed) {
      that.zoomed = false;
      zoomTarget.css('width', '');
      zoomTarget.css('padding-top', '');
      zoomTarget.css('transform', '');
      zoomTarget.removeClass('presentation-zoom');
      zoomTarget.addClass('bulb-content');

      // cover image
      const coverImg = jQuery('.bulb-has-cover-image').find('img');
      if (coverImg) {
        coverImg.css('left', '');
      }

      const documentWidth = jQuery(document).width();
      const parent = zoomTarget.parent();
      const vscrollbarWidth = parent.width() - zoomTarget.width();

      // resize
      const w = documentWidth - vscrollbarWidth;
      jQuery('#presentation-footer').width(w);
      jQuery('#presentation-footer-thumbnail-container').width(w);
      zoomTarget.parent().css('height', '');
    } else {
      fullscreenTarget.addClass('bulb-main');
    }
  };

  this.fetchUnits = function fetchUnits() {
    const options = {
      presentingCollection: true,
    };
    BulbUnitService.fetchParent(options).then(() => {
      that.parentUnit = BulbUnitService.parentUnit;
      that.previousUnit = BulbUnitService.previousSibling;
      that.nextUnit = BulbUnitService.nextSibling;
    });
  };

  this.saveLastState = function saveLastState(unit) {
    lastStateArg = {
      unitPath: unit.path,
    };
  };

  const createUsePublishedVersionCondition = function createUsePublishedVersionCondition(unit) { // jshint ignore:line
    return that.usePublishedVersion && (unit.unitType !== 'PublishedPageUnit'
      && unit.isPublished || unit.unitType === 'PublishedPageUnit');
  };

  // TODO FUTURE: I left the 'createUsePublishedVersionCondition' function in so that one day, we will implement
  // the workflow such that we can serve up the published page if need be, rather than always serving up the draft
  // page for presentation mode.
  this.changePage = function (unit) {
    userControllable = false;
    $state.go('presentation_page', {
      unitPath: unit.path,
    });
  };

  /**
   * Function that kicks off the presentation mode.
   *
   * @param unit The current unit that is going to be presented.
   */
  this.startPresentation = function startPresentation(unit) {
    this.showTransitionCover();
    this.enterFullscreen();
    this.changePage(unit);
  };

  this.exitPresentation = function exitPresentation(navigateToProfile) {
    hideTransitionCover();
    exitFullscreen();
    this.restoreZoom();

    jQuery('header.bulb-header').show();
    fullscreenTarget.css('background', 'transparent');
    fullscreenTarget.css('overflow-x', '');

    jQuery('#presentation-footer').remove();
    jQuery('#presentation-footer-thumbnail-container').remove();
    $document.off('keydown', onKeyDown);
    jQuery('#bulb-main').off('click', onClick);

    if (!navigateToProfile) {
      $state.go('unit.page', lastStateArg);
    }

    lastStateArg = null;
  };

  this.createHref = function createHref(unit) {
    // NOTE: I removed the 'createUsePublishedVersionCondition' because it was creating conflicts for the *author* to
    // Present their pages. I also updated the functionality in the presentationfooter-directive in the watcher for
    // '$includeLoadedContent'.
    return `presentation_page({unitPath: "${unit.path}"})`;
  };
}
